var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.125 12.015 3.31 1.84c.476.263.684.823.497 1.333-.95 2.593-3.73 3.962-6.345 3.007C6.23 16.24 2.26 12.27.305 6.913-.65 4.297.719 1.517 3.312.568c.51-.187 1.07.021 1.334.496q.919 1.656 1.839 3.31a1.35 1.35 0 0 1-.174 1.575L4.766 7.687c1.1 2.678 3.369 4.947 6.047 6.047l1.738-1.545a1.35 1.35 0 0 1 1.574-.174",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;